import { Grid, tooltipClasses, Typography } from "@mui/material";
import React, { useState } from "react";
import LeftArrow from "../Assests/Dashboard/Left.svg";
import { Link, useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import { Tooltip, IconButton } from "@mui/material";
import { styled } from "@mui/system";
import { useMediaQuery } from "@mui/material";
import HoverInfoLogo from "../reuseableComponents/HoverInfoLogo";

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#f5f5f9",
    "&::before": {
      border: "1px solid var(--qv-bd-0a64f9, #0a64f9)",
      backgroundColor: "var(--qv-bg-ffffff, #fff)",
    },
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "transparent",
    color: "var(--qv-tx-a0x0x0x870, rgba(0, 0, 0, 0.87))",
  },
  [`&[data-popper-placement*="right"] .${tooltipClasses.arrow}`]: {
    marginLeft: "0.14em",
    marginBottom: "0px",
  },
  [`&[data-popper-placement*="top"] .${tooltipClasses.arrow}`]: {
    marginBottom: "-0.23em",
  },
  [`&[data-popper-placement*="top"] .MuiTooltip-tooltip`]: {
    marginBottom: "0px !important", // Adjust as needed
  },
}));
export default function SwitchToBackButton({ linkTo, title, productId }) {
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const [close, setClose] = useState(true);
  const navigate = useNavigate();
  const [open, setOpen] = useState(true); // Start with the tooltip visible

  const handleCancel = () => {
    setOpen(false); // Hide the tooltip when cancel is clicked
  };
  const handleClose = (e) => {
    e.stopPropagation();
    setClose((prev) => !prev);
  };

  const redirectOnDuplicate = () => {
    navigate(`/inventory/new-products/duplicate/${productId?.id}`);
  };

  // Keep the rim on this span — a border on the img is inverted by dark-theme icon filters.
  const backIcon = (
    <span className="qv-switch-back-icon">
      <img src={LeftArrow} alt="Add-New-Vendors" />
    </span>
  );

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid
          sx={{ px: { xs: 1, sm: 2.5 } }}
          className="q-add-categories-section-header"
        >
          {linkTo?.includes("/inventory/new-products") && close ? (
            <CustomTooltip
              PopperProps={{
                style: { zIndex: 1 }, // Adjust as needed
              }}
              sx={{
                backgroundColor: "transparent", // Remove background color
                boxShadow: "none", // Optional: remove shadow if desired
              }}
              open={open}
              placement={isSmallScreen ? "top" : "right"}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Link
                  to={linkTo}
                  className={
                    linkTo === "/inventory/new-products"
                      ? "product-heading-title"
                      : ""
                  }
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {backIcon}
                  <span>{title}</span>
                </Link>
                <HoverInfoLogo
                  title={
                    "A few special characters are not allowed: ( ~, /, \\, ,, - )"
                  }
                  placement="bottom-start"
                />
              </div>
            </CustomTooltip>
          ) : (
            <Link
              to={linkTo}
              className={
                linkTo === "/inventory/new-products" ? "product-heading-title" : ""
              }
            >
              {backIcon}
              <span>{title}</span>
            </Link>
          )}

          {/* {linkTo === "/inventory/new-products" && close ? (
            <div className="product-error-note">
              <span className="whitespace-nowrap">
                Special characters not allowed
              </span>
              <CancelIcon onClick={handleClose} />
            </div>
          ) : (
            ""
          )} */}
          {title === "Edit Product" ? (
            <button
              className="quic-btn quic-btn-bulk-edit duplicate-product"
              onClick={() => redirectOnDuplicate()}
            >
              Duplicate Product
            </button>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
